import { render, staticRenderFns } from "./HerosAdd.vue?vue&type=template&id=088e1443&scoped=true"
import script from "./HerosAdd.vue?vue&type=script&lang=js"
export * from "./HerosAdd.vue?vue&type=script&lang=js"
import style0 from "./HerosAdd.vue?vue&type=style&index=0&id=088e1443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e1443",
  null
  
)

export default component.exports